import type { SentryRequest } from './types';
import { scrubUrl } from './scrub-url';

/**
 * The ONLY request headers allowed through to Sentry. Everything else — cookies,
 * auth, custom headers — is dropped. Compared case-insensitively.
 */
export const ALLOWED_REQUEST_HEADERS: readonly string[] = [
  'user-agent',
  'x-correlation-id',
  'x-request-id',
];

const allowed = new Set(ALLOWED_REQUEST_HEADERS);

const filterHeaders = (headers: Record<string, string>): Record<string, string> =>
  Object.fromEntries(Object.entries(headers).filter(([key]) => allowed.has(key.toLowerCase())));

/**
 * Strip the request down to the safe minimum: drop body/query/cookies, reduce
 * headers to the allow-list, and route-template the URL.
 */
export const scrubRequest = (request: SentryRequest): void => {
  delete request.cookies;
  delete request.data;
  delete request.query_string;

  if (request.headers) {
    request.headers = filterHeaders(request.headers);
  }

  if (typeof request.url === 'string') {
    request.url = scrubUrl(request.url);
  }
};
